import { TenantKey } from '@app/core/enums/tenant-key.enum';
import { ClerkCreateGuardianshipFormComponent } from '../../components/clerk-create-guardianship-form/clerk-create-guardianship-form.component';
import { ClerkCreateProbateFormComponent } from '../../components/clerk-create-probate-form/clerk-create-probate-form.component';
import { ClerkCreateMinorFormComponent } from '../../components/clerk-create-minor-form/clerk-create-minor-form.component';
import { ClerkCreateTrustFormComponent } from '../../components/clerk-create-trust-form/clerk-create-trust-form.component';

export const TENANT_KEY_CREATE_FORM_OUTLET_MAP = {
  [TenantKey.PROBATE]: ClerkCreateProbateFormComponent,
  [TenantKey.GUARDIANSHIP]: ClerkCreateGuardianshipFormComponent,
  [TenantKey.MINOR]: ClerkCreateMinorFormComponent,
  [TenantKey.TRUST]: ClerkCreateTrustFormComponent,
} as const;
